export enum Environments {
  Development = 'dev',
  Sandbox = 'sand',
  Production = 'prod',
}
